import empty from '@/assets/js/functions/empty.js';
import RoleEnum from '@/assets/js/consts/roles.const';

const USER_STORE_SUPPLIER = {
  id: RoleEnum.supplier,
  state: () => ({
    loaded: false,
    data: Object.create(null),
    activeWarehouse: Object.create(null),
  }),
  getters: {
    get_data: state => state.data,
    getActiveWarehouse: state => state.activeWarehouse,
    is_user_loaded: state => state.loaded,
    is_warehouse_completed: state =>
      state.activeWarehouse.shipping?.type &&
      state.activeWarehouse.title &&
      state.activeWarehouse.city_id,
    is_user_completed: state => {
      const necessary_fields = [state.data.name, state.data.national_code];
      return necessary_fields.every(field => !empty(field));
    },
  },
  actions: {
    set_loaded() {
      this.loaded = true;
    },
    is_empty() {
      return !this.data.id;
    },
    isWarehouseEmpty() {
      return !this.activeWarehouse?.id;
    },
    get() {
      return this.data;
    },
    set(data) {
      this.data = data;
    },
    setWarehouse(data) {
      this.activeWarehouse = data;
    },
    update(data) {
      Object.assign(this.data, data);
    },
    make_empty() {
      this.set(Object.create(null));
    },
  },
};

const USER_STORE_ADMIN = {
  ...USER_STORE_SUPPLIER,
  id: RoleEnum.admin,
};

export { USER_STORE_SUPPLIER, USER_STORE_ADMIN };
